import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import appdata from './reducers';

export interface RootState {
  appdata: any;
}

const rootReducer = combineReducers({
  appdata: appdata
});

const configureStore = () => {
  return createStore(
    rootReducer,
    compose(applyMiddleware(thunk))
  );
};

export default configureStore;